(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["market-payment-icons"] && !Shopify.designMode) return;
  try {
    (() => {
    const updateCartPayments = () => {
      const source = document.querySelector('.footer__payment .list-payment:has(.belluna-market-payment)') ||
        document.querySelector('.payment-badges:has(.belluna-market-payment)');
      if (!source) return;
      const icons = Array.from(source.querySelectorAll('.belluna-market-payment'));
      const signature = icons.map(item => item.dataset.bellunaPaymentType).join(',');
      document.querySelectorAll('.kaching-cart__payment-icons').forEach(container => {
        if (container.dataset.bellunaPayments === signature &&
            container.querySelectorAll('.belluna-cart-payment').length === icons.length) return;
        const copies = icons.map((item, index) => {
          const svg = item.querySelector('svg').cloneNode(true);
          svg.classList.add('belluna-cart-payment');
          const title = svg.querySelector('title');
          if (title) {
            title.id = `belluna-cart-payment-${index}`;
            svg.setAttribute('aria-labelledby', title.id);
          }
          return svg;
        });
        container.replaceChildren(...copies);
        container.dataset.bellunaPayments = signature;
      });
    };
    updateCartPayments();
    new MutationObserver(updateCartPayments).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
